"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "madonna-del-sasso": {
    "97255544": [{
      "hkey": "c02b2358",
      "slug": "arto-centonara",
      "name": "Artò-Centonara",
      "primary": true,
      "skipSearch": false
    }],
    "arto": [{
      "hkey": "c02b2358",
      "slug": "arto-centonara",
      "name": "Artò-Centonara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50a50d57": [{
      "hkey": "c02b2358",
      "slug": "arto-centonara",
      "name": "Artò-Centonara",
      "primary": true,
      "skipSearch": false
    }],
    "centonara": [{
      "hkey": "c02b2358",
      "slug": "arto-centonara",
      "name": "Artò-Centonara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "madonna-del-sasso"
    }],
    "76d9ea9c": [{
      "hkey": "18ad16ab",
      "slug": "madonna-del-sasso",
      "name": "Madonna del Sasso",
      "primary": true,
      "skipSearch": false
    }],
    "valico-di-colma": [{
      "hkey": "18ad16ab",
      "slug": "madonna-del-sasso",
      "name": "Madonna del Sasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;